export const BREADCRUMB_ID = 'breadcrumb-wrapper'

export const SERVICE_CATEGORY_CONTENT_ID = 'service-category-content-wrapper'

export const SERVICE_CATEGORY_CTA_WRAPPER_ID = 'service-category-cta-wrapper'

export const SERVICE_CATEGORY_EMPTY_STATE = {}

export const SERVICE_SHORTENED_NAMES = {
  'cat-tire-service-and-repair': 'Tire',
  'cat-alignment': 'Alignment',
  'cat-batteries': 'Battery',
  'cat-brakes': 'Brake',
  'cat-oil-lube-and-filter': 'Oil Change',
  'cat-routine-services-and-fluids': 'Routine',
  'cat-suspension-and-front-end': 'Suspension'
}

export const SERVICE_ALIASES = {
  'cat-alignment': 'Wheel Alignments',
  'cat-batteries': 'Car Batteries and Electrical Repair',
  'cat-routine-services-and-fluids': 'Automotive Services',
  'cat-suspension-and-front-end': 'Suspension Service, Shocks and Struts',
  'cat-oil-lube-and-filter': 'Oil Changes'
}
